import { useState } from 'react';
import type { Tone } from '../../components/tone';
import { jordanDate, shortDate } from '@serb/shared';
import { addDays } from '../../lib/dates';
import { SAMPLE_DATA } from '../../lib/sample';
import { SAMPLE_TODAY, SAMPLE_YESTERDAY, type ActivityStatus } from './sample';
import { useCommunications } from './useCommunications';

export const STATUS_TONE: Record<ActivityStatus, Tone> = {
  'New Update': 'info',
  'Needs Attention': 'error',
  'Awaiting Reply': 'warning',
  Updated: 'success',
  'Pending Approval': 'neutral',
};
export const STATUSES = Object.keys(STATUS_TONE) as ActivityStatus[];

/** "23 Jul 2025" → "Today" / "Yesterday" / "21 Jul 2025" */
export const dayName = (date: string) => {
  const today = SAMPLE_DATA ? SAMPLE_TODAY : shortDate(jordanDate());
  const yesterday = SAMPLE_DATA ? SAMPLE_YESTERDAY : shortDate(addDays(jordanDate(), -1));
  return date === today ? 'Today' : date === yesterday ? 'Yesterday' : date;
};

/** Which day, kind of update and contact are chosen, and the feed lines that match */
export function useActivityFilters() {
  const [day, setDay] = useState('all');
  const [status, setStatus] = useState('all');
  const [party, setParty] = useState('all');
  const { events } = useCommunications();
  const shown = events
    .filter((e) => day === 'all' || dayName(e.date) === day)
    .filter((e) => status === 'all' || e.status === status)
    .filter((e) => party === 'all' || e.party === party);
  return { day, setDay, status, setStatus, party, setParty, shown };
}
export type ActivityFilters = ReturnType<typeof useActivityFilters>;
